import { AbstractControl, ValidationErrors } from '@angular/forms';

export function passwordValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if (!value) return null;

  const errors: ValidationErrors = {};

  if (value.length < 8) {
    errors['minLength'] = {
      requiredLength: 8,
      actualLength: value.length
    };
  }

  if (!/[A-Z]/.test(value)) {
    errors['uppercase'] = true;
  }

  if (!/[0-9]/.test(value)) {
    errors['number'] = true;
  }

  return Object.keys(errors).length ? errors : null;
}
